import { render } from "./AppointmentManagement.vue?vue&type=template&id=755df5e0&scoped=true"
import script from "./AppointmentManagement.vue?vue&type=script&lang=js"
export * from "./AppointmentManagement.vue?vue&type=script&lang=js"

import "./AppointmentManagement.vue?vue&type=style&index=0&id=755df5e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755df5e0"]])

export default __exports__